module.exports = __webpack_public_path__ + "static/media/BG_PDJ_Assessment.0cfb87b9.jpg";